import { reactive, provide, toRefs } from "vue";
import { User } from '@/domain/entities/User';
import AuthFacade, { UserStatus } from '@/infraestructure/auth/auth_facade';
import { db, functions } from '../infraestructure/datasource'
import { UserType } from '@/domain/entities/UserTypes';
import { pprint } from '@/helpers/pprint';
import { useRoute, useRouter } from 'vue-router';
import { isMobile } from "@/helpers/device";

const USER_TYPE_KEY = 'usertype'
const userType = (type? : UserType) : UserType | void => {
	if (type) {
		window.localStorage.setItem(USER_TYPE_KEY, type)
	}
	return window.localStorage.getItem(USER_TYPE_KEY) as UserType
}
const deleteUserType = () => {
	state.type = null
	window.localStorage.removeItem(USER_TYPE_KEY)
}

interface AuthState {
	user: User | null,
	authStatus: UserStatus,
	type: UserType | null,
}

const state = reactive<AuthState>({
	user: null,
	authStatus: UserStatus.Unknown,
	type: userType() || null
})

const authFacade: AuthFacade = new AuthFacade();

const init = () => {
	let router = useRouter()
	let route = useRoute()

	pprint('AuthState INIT ---')
	provide(AuthFacade.key, authFacade);

	if (state.type == null) {
		signOut()
		router.push({
			path: '/login'
		})
	}

	authFacade.userBehaviorSubject.subscribe(async (userStatus) => {
		if (userStatus.status === UserStatus.SignedOut && route.path !== '/login') {
			router.push({
				path: '/login'
			})
		}
		if (userStatus.status === UserStatus.SignedIn) {
			let type = userType()
			state.user = <User>{
				id: authFacade.user?.uid,
				email: authFacade.user?.email,
				typeUser: type,
			}
		}
		state.authStatus = userStatus.status;
	});
}


const updateFCMToken = async (token: string) => {
	let userRef = db.collection(
		state.user?.typeUser === UserType.Patient ? 'patients' : 'doctors').doc(state.user?.id)
	if (isMobile()) {
		await userRef.set({
			FCMToken: token
		}, { merge: true })
	} else {
		await userRef.set({
			FCMTokenDesktop: token
		}, { merge: true })
	}
}

const signIn = async (type: UserType) => {
	state.user = await authFacade.login(type)
	userType(type)
}

const signOut = async () => {
	await authFacade.logout()
	deleteUserType()
}

const verifyDoctor = async (keyword : string) => {
	let resp = await functions.httpsCallable('verifyDoctor')({ keyword })
	console.log('resp', resp);
	
	return resp.data.isDoctor
}

export default function useAuth() {
	return { ...toRefs(state), init, authFacade,
		updateFCMToken, statusListener: authFacade.userBehaviorSubject,
		signOut, signIn, verifyDoctor }
}
